<template>
    <div class="font-size-h2 text-footer px-4 my-5">REGISTRATION IS CURRENTLY NOT AVAILABLE.</div>
</template>

<script>
/* eslint-disable */
    export default {
        name: 'FeatureDisabled',
    }
</script>